import colors from '../../../../theme/foundations/colors'
import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'

export const buttonStyle = {
    _hover: {textDecoration: 'underline'},
    color: colors.cav_calltoaction_darkred,
    fontFamily: fonts.primary,
    letterSpacing: pxToRem(1),
    lineHeight: 'normal',
    fontWeight: 500,
    fontSize: {base: pxToRem(10), md: pxToRem(12)},
    fontStyle: 'normal'
}
